import { type Common } from './common.js';
import type * as AgenticPlatform from './models/agenticPlatform.js';

export class API {
  common: Common;
  readonly baseEndpoint = '/agentic-platform/sessions';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(): Promise<AgenticPlatform.AgenticPlatformSession[]> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.getJSON(url);
  }

  async create(
    values: AgenticPlatform.CreateAgenticPlatformSessionValues
  ): Promise<AgenticPlatform.AgenticPlatformSession> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async findAllMessages(sessionId: string): Promise<AgenticPlatform.AgenticPlatformMessage[]> {
    const url = this.common.constructPath(
      `${this.baseEndpoint}/${encodeURIComponent(sessionId)}/messages`
    );
    return await this.common.getJSON(url);
  }
}
